import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { ContactsLoginsFormikValues } from './models/contacts-logins-formik-values';

const fieldNames = fields<ContactsLoginsFormikValues>();

export const contactsLoginsValidationSchema = Yup.object().shape({
    [fieldNames.formOfAddress]: Yup.number().required('app.error.required'),
    [fieldNames.positionId]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [fieldNames.lastName]: Yup.string().required('app.error.required'),
    [fieldNames.firstName]: Yup.string().required('app.error.required'),
    [fieldNames.phone]: Yup.string(),
    [fieldNames.email]: Yup.string().email('app.error.email').required('app.error.required'),
    [fieldNames.monthlyOrderCeiling]: Yup.number().when('isUser', {
        is: true,
        then: Yup.number().required('app.error.required'),
    }),
    [fieldNames.perOrderOrderCeiling]: Yup.number().nullable().when('isUser', {
        is: true,
        then: Yup.number(),
    }),
});
